import {
  REQUEST_COMPLETED_STATUS,
  REQUEST_DENIED_STATUS,
  REQUEST_IN_PROGRESS_STATUS,
  REQUEST_PENDING_STATUS,
} from '../../../../constants/request'
import {
  BirdviewChartTone,
  BirdviewCustomerSegment,
} from '../../DashboardBirdview.constants.charts'

export const BIRDVIEW_CHART_CUSTOMER_SEGMENTS = {
  [BirdviewCustomerSegment.Contact]: [
    {
      apiKey: 'email',
      color: BirdviewChartTone.Success,
      labelKey: 'DashboardBirdview.UsersContactEmailKey',
    },
    {
      apiKey: 'phone_and_email',
      color: BirdviewChartTone.Info,
      labelKey: 'DashboardBirdview.UsersContactPhoneAndEmailKey',
    },
    {
      apiKey: 'phone',
      color: BirdviewChartTone.Warning,
      labelKey: 'DashboardBirdview.UsersContactPhoneKey',
    },
    {
      apiKey: 'empty_contact',
      color: BirdviewChartTone.Error,
      labelKey: 'DashboardBirdview.UsersContactNoneKey',
    },
  ],
  [BirdviewCustomerSegment.Role]: [
    {
      apiKey: 'dwellers',
      color: BirdviewChartTone.Info,
      labelKey: 'DashboardBirdview.UsersRoleDwellersKey',
    },
    {
      apiKey: 'landlords',
      color: BirdviewChartTone.Success,
      labelKey: 'DashboardBirdview.UsersRoleLandlordsKey',
    },
  ],
  [BirdviewCustomerSegment.Status]: [
    {
      apiKey: 'online',
      color: BirdviewChartTone.Success,
      labelKey: 'DashboardBirdview.UsersStatusOnlineKey',
    },
    {
      apiKey: 'invited',
      color: BirdviewChartTone.Warning,
      labelKey: 'DashboardBirdview.UsersStatusInvitedKey',
    },
    {
      apiKey: 'imported',
      color: BirdviewChartTone.Info,
      labelKey: 'DashboardBirdview.UsersStatusImportedKey',
    },
    {
      apiKey: 'blocked',
      color: BirdviewChartTone.Error,
      labelKey: 'DashboardBirdview.UsersStatusBlockedKey',
    },
    {
      apiKey: 'invalid',
      color: BirdviewChartTone.Purple,
      labelKey: 'DashboardBirdview.UsersStatusInvalidKey',
    },
  ],
}

export const BIRDVIEW_CHART_REQUEST_STATUS_SEGMENTS = [
  { color: BirdviewChartTone.Info, status: REQUEST_PENDING_STATUS },
  { color: BirdviewChartTone.Warning, status: REQUEST_IN_PROGRESS_STATUS },
  { color: BirdviewChartTone.Success, status: REQUEST_COMPLETED_STATUS },
  { color: BirdviewChartTone.Error, status: REQUEST_DENIED_STATUS },
]

// minDays is inclusive and maxDays exclusive. Requests younger than the first
// bucket have no column and count only in the total.
export const BIRDVIEW_CHART_AGING_BUCKETS = [
  {
    apiKey: '7_13',
    color: BirdviewChartTone.Success,
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 14,
    minDays: 7,
  },
  {
    apiKey: '14_29',
    color: BirdviewChartTone.Info,
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 30,
    minDays: 14,
  },
  {
    apiKey: '30_89',
    color: BirdviewChartTone.Warning,
    labelKey: 'DashboardBirdview.AttentionAgeRangeOptionKey',
    maxDays: 90,
    minDays: 30,
  },
  {
    apiKey: '90_plus',
    color: BirdviewChartTone.Error,
    labelKey: 'DashboardBirdview.AttentionAgeFromOptionKey',
    minDays: 90,
  },
]

export const BIRDVIEW_CHART_OTHER_ITEM = {
  id: 'other',
  labelKey: 'DashboardBirdview.ChartOtherKey',
}

export const BIRDVIEW_CHART_OTHER_CATEGORIES_ITEM = {
  ...BIRDVIEW_CHART_OTHER_ITEM,
  labelKey: 'DashboardBirdview.ChartOtherCategoriesKey',
}

export const BIRDVIEW_CHART_OTHER_BUILDINGS_ITEM = {
  ...BIRDVIEW_CHART_OTHER_ITEM,
  isOpenable: true,
}

export const BIRDVIEW_CHART_NO_CATEGORY_ITEM = {
  id: 'noCategory',
  labelKey: 'DashboardBirdview.ChartNoCategoryKey',
}

export const BIRDVIEW_CHART_UNASSIGNED_ITEM = {
  id: 'unassigned',
  isMuted: true,
  labelKey: 'DashboardBirdview.TileUnassignedKey',
}
